module.exports = __webpack_public_path__ + "static/img/login_close@3x.295317c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_close@3x.png
// module id = d7KY
// module chunks = 1